module.exports = __webpack_public_path__ + "img/jinniao_icon04.e1230567.png";